<template>
  <div class="sr__comment">
    <!-- new commnet -->
     <div class="sr__comment-new-box" v-if="canNewComment">
      <div class="sr__comment-new">
        <button
          class="sr__comment-btn"
          v-show="!commentCreating"
          @click="toNewComment"
        >
          <span>{{addCommentLabel}}</span>
        </button>

        <div
          class="sr__comment-box"
          v-show="commentCreating"
        >
          <textarea
            ref="commentRef"
            @input="autoTextareaHeight($event.target)"
            placeholder="請輸入..."
            v-model="newCommentContent"
          ></textarea>

          <div class="d-flex justify-content-end">
            <button
              class="sr__comment-action mr-1"
              @click="commentCreating=!commentCreating"
              :disabled="createCommenting"
            >取消</button>

            <button
              class="sr__comment-action sr__comment-action--submit"
              @click="createComment"
              :disabled="createCommenting"
            >{{ `送出${this.createCommenting ? '中...' : ''}` }}</button>
          </div>
        </div>
      </div>
     </div>

    <!-- comments -->
    <div
      v-if  = "canViewComments"
      class = "mb-2"
    >
      <div
        v-for = "cmt in comments"
        :key  = "`${cmt.id}`"
      >
        <Comment
          :orgCmt         = "cmt"
          :recordId       = "record.id"
          :lineId         = "lineId"
          @destroyComment = "destroyedComment"
        ></Comment>
      </div>
      <div ref="bottomMarker"></div>
    </div>
  </div>
</template>

<script>
import Comment from './Comment.vue'

export default {
  name: 'CommentList',
  props: {
    record: Object,
    canNewComment: Boolean,
    canViewComments: Boolean,
    addCommentLabel: String,
    apiType: String
  },
  data () {
    return {
      lineId: null,
      newCommentContent: '',
      commentCreating: false,
      createCommenting: false,
      comments: []
    }
  },
  created () {
    console.log('CommentList created')
    this.lineId = this.$store.state.userId
    this.getComments()
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        const bottom = this.$refs.bottomMarker

        if (bottom) {
          bottom.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    apiUrl (action) {
      return `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${this.record.id}/${this.apiAction(action)}`
    },
    apiAction (action) {
      var base = 'comment'
      if (action === 'get') {
        base = `${base}s`
      }

      if (this.apiType) {
        return `${action}_${this.apiType}_${base}`
      }

      return `${action}_${base}`
    },
    async createComment () {
      this.createCommenting = true
      const options = {
        comment: {
          content: this.newCommentContent
        }
      }

      var r = false
      try {
        const resp = await this.$api.post(this.apiUrl('add'), options)
        this.comments.push(resp.comment)

        this.newCommentContent = ''
        this.commentCreating = false
        this.scrollToBottom()
        r = true

        this.$emit('updateCommentCount', this.record.comment_count + 1)
      } catch (e) {
        console.error(e)
      }

      this.createCommenting = false
      return r
    },
    destroyedComment () {
      this.$emit('updateCommentCount', this.record.comment_count - 1)
    },
    async getComments () {
      if (!this.canViewComments) {
        return
      }

      this.comments = []
      try {
        const resp = await this.$api.get(this.apiUrl('get'))
        this.comments = resp.comments

        this.$emit('updateCommentCount', this.comments.length)
        return true
      } catch (e) {
        console.error(e)
        return false
      }
    },
    autoTextareaHeight (target) {
      this.$nextTick(() => {
        target.style.height = target.scrollHeight + 'px'
      })
    },
    toNewComment () {
      this.commentCreating = !this.commentCreating
      this.$nextTick(() => {
        this.$refs.commentRef.focus()
      })
    }
  },
  components: {
    Comment
  }
}
</script>
